import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import { dropdownMenuLinkPropTypes } from './dropdownMenuLinkPropTypes';
import { availableValuesIdDisplayNameObject } from './availableValuePropTypes';
import { intlMessageShape } from './intlMessageShape';
import { appSwitcherItemsObject } from './appSwitcherRoutePropTypes';
import { linkShape } from './linkShape';
import { avatarShape } from './avatarPropTypes';
var lookupOptionShape = PropTypes.shape(_objectSpread({}, availableValuesIdDisplayNameObject, {
  type: PropTypes.string.isRequired
}));
var dropdownMenuLinkShape = PropTypes.shape(_objectSpread({}, dropdownMenuLinkPropTypes, {
  title: intlMessageShape
}));
export var applicationHeaderPropTypes = {
  className: PropTypes.string,
  logoSrc: PropTypes.string,
  logoUrl: PropTypes.string,
  logoTitle: intlMessageShape,
  onSearchValueChange: PropTypes.func,
  onLoadValues: PropTypes.func,
  searchAvailableValues: PropTypes.arrayOf(lookupOptionShape.isRequired),
  showNotifications: PropTypes.bool,
  notificationChildren: PropTypes.node,
  showAvatar: PropTypes.bool,
  avatarChildren: PropTypes.node,
  avatarProps: avatarShape,
  commonAvatarRoutes: PropTypes.arrayOf(dropdownMenuLinkShape.isRequired),
  searchFieldPlaceholder: intlMessageShape,
  showAppSwitcher: PropTypes.bool,
  appSwitcherItems: appSwitcherItemsObject,
  useAuthInfo: PropTypes.bool,
  showHelp: PropTypes.bool,
  helpUrl: PropTypes.oneOfType([intlMessageShape, linkShape]),
  helpPopoverItems: PropTypes.arrayOf(PropTypes.object),
  callbackMap: PropTypes.shape({}),
  appSwitcherFooterText: intlMessageShape,
  appSwitcherFooterUrl: intlMessageShape,
  onAppSwitcherFooterClick: PropTypes.func,
  appSwitcherSearchEnabled: PropTypes.bool,
  appSwitcherCollapsibleGroupsThreshold: PropTypes.number,
  appSwitcherHideFooter: PropTypes.bool
};